@for (tabElementRoot of tabElements; track tabElementRoot) { @if (tabElementRoot.children &&
tabElementRoot.children[0].columnOne && !tabElementRoot.type) {
<tab-container class="-secondary">
  @for (tabElement of tabElementRoot.children; track tabElement) {
  <tab-item [title]="tabElement.title" [attr.tab-title]="tabElement.title">
    <div class="-container">
      @if (tabElement.columnOne) {
      <ng-container *ngTemplateOutlet="column; context: { column: tabElement.columnOne }"></ng-container>
      } @if (tabElement.columnTwo) {
      <ng-container *ngTemplateOutlet="column; context: { column: tabElement.columnTwo }"></ng-container>
      } @if (tabElement.columnThree) {
      <ng-container *ngTemplateOutlet="column; context: { column: tabElement.columnThree }"></ng-container>
      }
    </div>
  </tab-item>
  }
</tab-container>
} }

<ng-template #column let-column="column">
  <div class="-columns">
    <h4>{{ column.title }}</h4>
    @for (child of column.children; track child) {
    <h5>{{ child.title }}</h5>
    <p>{{ child.description }}</p>
    @for (link of child.links; track link) {
    <app-link [to]="link.path" [externaloverride]="link.external"
      >{{ link.title }}
      @if (link.pdf) {
      <p class="-pdf">PDF</p>
      }
    </app-link>
    } }
  </div>
</ng-template>
